import { Pipe, PipeTransform, NgModule } from '@angular/core';
import { Assignment } from '@apaq/orgkit-js';

@Pipe({
  name: 'resolveDuration',
})
export class ResolveDurationPipe implements PipeTransform {

  transform(input: Assignment): any {
    
    let assignment = input;
    let totalMinutes = 0;
    assignment.tasks.forEach(t => totalMinutes += t.duration);
    return totalMinutes;
  }

}